/** @hidden */
export function isBoolean(val: any): val is boolean {
  return typeof val === 'boolean';
}
/** @hidden */
export function isString(val: any): val is string {
  return typeof val === 'string';
}
/** @hidden */
export function isNumber(val: any): val is number {
  return typeof val === 'number';
}
/** @hidden */
export function isFunction(val: any): val is Function {
  return typeof val === 'function';
}
/** @hidden */
export function isDefined(val: any): boolean {
  return typeof val !== 'undefined';
}
/** @hidden */
export function isUndefined(val: any): val is undefined {
  return typeof val === 'undefined';
}
/** @hidden */
export function isPresent(val: any): val is any {
  return val !== undefined && val !== null;
}
/** @hidden */
export function isBlank(val: any): val is null {
  return val === undefined || val === null;
}
/** @hidden */
export function isObject(val: any): val is Object {
  return typeof val === 'object';
}
/** @hidden */
export function isArray(val: any): val is any[] {
  return Array.isArray(val);
}

export class Custom_RequestMethod {
  post: any = 'post';
  get: string = 'get';
  delete: any = 'Delete';
  put: any = 'put';
}

export function removeEmptyKeys(obj: any) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      (entry: any) => entry[1] != '' && entry[1] != null && entry[1] != undefined
    )
  );
}
export function ensureHttpPrefix(url: string, notSecure: boolean = false): string {
  // Check if the URL starts with http:// or https://
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    // If not, prepend http:// to the URL
    if (notSecure) return 'http://' + url;
    else return 'https://' + url;
  }
  // If the URL already has http:// or https://, return it as is
  return url;
}

export function encodeSpaces(url: string): string {
  return url.replace(/ /g, '%20');
}

/**
 * Safely get a nested property value using dot notation.
 *
 * @param obj The source object
 * @param path The dot-notation path (e.g., 'address.city', 'player.handicap.index')
 * @returns The value at the path, or undefined if not found
 *
 * @example
 * const player = { name: 'John', location: { city: 'NYC' } };
 * getNestedValue(player, 'location.city'); // returns 'NYC'
 * getNestedValue(player, 'location.country'); // returns undefined
 */
export function getNestedValue<T>(obj: any, path: string): T | undefined {
  if (!obj || !path) {
    return undefined;
  }

  return path.split('.').reduce((current: any, key: string) => current?.[key], obj);
}

/**
 * Safely set a nested property value using dot notation.
 * Creates intermediate objects if they don't exist.
 *
 * @param obj The target object
 * @param path The dot-notation path (e.g., 'address.city', 'player.handicap.index')
 * @param value The value to set
 *
 * @example
 * const player = { name: 'John' };
 * setNestedValue(player, 'location.city', 'NYC');
 * // player is now { name: 'John', location: { city: 'NYC' } }
 */
export function setNestedValue(obj: any, path: string, value: any): void {
  if (!obj || !path) {
    return;
  }

  const keys = path.split('.');
  const lastKey = keys.pop();

  if (!lastKey) {
    return;
  }

  // Navigate to the parent object, creating intermediate objects if needed
  const target = keys.reduce((current: any, key: string) => {
    if (!current[key] || typeof current[key] !== 'object') {
      current[key] = {};
    }
    return current[key];
  }, obj);

  // Set the value on the parent object
  target[lastKey] = value;
}

export function getRange(n: number, start?: number): number[] {
  return Array(n)
    .fill(0)
    .map((_, index) => index + start);
  // return Array(n).fill(0).map((_, index) => index);
}
//https://github.com/ionic-team/ionic-v3/blob/master/src/util/util.ts#L98
